import React from 'react';
import SystemModal from 'components/Shared/Modal';
import ScaIframe from '../PASFormView/ScaIframe';
import useTranslation from 'utils/hooks/useTranslation';

// `challengeHtml` is the decoded challenge document (PAS card creation, wallet card load);
// `challengeUrl` is a provider-hosted challenge page (wallet card load). `footerContent` lets a
// host add guidance under the iframe, e.g. an open-in-new-window fallback for a URL challenge.
const ScaOrderChallengeModal = ({
  onCancel,
  challengeHtml,
  challengeUrl,
  visible,
  footerContent = null,
}) => {
  const { translateText } = useTranslation();
  const MODAL_WIDTH = 697;

  return (
    <SystemModal
      data-testid="scaChallengeModal"
      footer={null}
      onCancel={onCancel}
      visible={visible}
      width={MODAL_WIDTH}
      title={translateText('corporateAccounts.payments.spa.challenge.title')}
    >
      <ScaIframe iframeHtml={challengeHtml} src={challengeUrl} />
      {footerContent}
    </SystemModal>
  );
};

export default ScaOrderChallengeModal;
